import type { ProjectCampaign } from '@/entities/media-campaign';

export interface AvailableFilterOptions {
  platforms: string[];
  channels: string[];
}

/**
 * The values the filter chips may offer.
 *
 * Taken from the project's own campaigns rather than from the loaded breakdown, because
 * the breakdown is already narrowed by these very filters: reading it would delete the
 * option needed to undo a selection. Filter to a platform the current scope has none of
 * and the breakdown comes back empty, leaving an active `platforms=` in the URL with no
 * chip on screen to clear it.
 */
export function availableFilterOptions(
  campaigns: readonly ProjectCampaign[] | undefined,
): AvailableFilterOptions {
  const list = campaigns ?? [];
  return {
    platforms: [
      ...new Set(
        list
          .map((campaign) => campaign.platform)
          .filter((platform): platform is string => platform !== null),
      ),
    ],
    channels: [
      ...new Set(
        list
          .map((campaign) => campaign.channel)
          .filter((channel): channel is string => channel !== null),
      ),
    ],
  };
}
